// Declenche le telechargement d'un blob PDF SANS passer par window.open.
//
// Pourquoi : window.open(URL.createObjectURL(...)) est bloque par le bloqueur
// de pop-ups (Firefox notamment) car il est appele APRES un `await` (la requete
// PDF) -> le navigateur considere que le "user gesture" du clic est perdu et
// bloque la pop-up, sans erreur visible. Un clic programmatique sur une ancre
// <a download> n'est jamais bloque (c'est un telechargement same-origin).
//
// @param {ArrayBuffer|Blob} data - corps de la reponse PDF (responseType:'blob')
// @param {string} filename - nom de fichier propose au telechargement
export default function downloadPdfBlob(data, filename = 'document.pdf') {
  const url = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Liberer la memoire une fois le telechargement demarre (revoke immediat
  // peut annuler le telechargement sur certains navigateurs).
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}
